module.exports = __webpack_public_path__ + "static/mod_poster-3b5a19db36497911a64afc63ed3bd147.gif";